import { BaseService } from '@/modules/Core/services/BaseService'
import type { AxiosResponse } from 'axios'
import type { IResponseApi } from '@/modules/Core/interfaces/api/IApis'
import type { IConfDocjson, IConfDocjsonservicios } from '@/modules/Configuracion/interfaces'
export class DocJsonService extends BaseService<IConfDocjson> {
  constructor () {
    super({
      baseUrl: 'system/docjson/'
    })
  }
  async serviciosPatologia(): Promise<AxiosResponse<IResponseApi<IConfDocjsonservicios[]>>> {
    return this.http.get<IResponseApi<IConfDocjsonservicios[]>>(`/servicios-patologia`)
  }
}
